class MaterialTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.material-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.material-tabs__panel'));
    this.mediaItems = Array.from(this.querySelectorAll('.material-tabs__media-item'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.panel));
    });
  }

  activate(panelId) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.panel === panelId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.mediaItems.forEach((item) => {
      const isActive = item.dataset.panel === panelId;
      item.classList.toggle('is-active', isActive);

      const video = item.querySelector('video');
      if (!video) return;

      if (isActive) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('material-tabs')) {
  customElements.define('material-tabs', MaterialTabs);
}
